import React,{useState,useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import useStyles, { getMuiTheme } from "./styles";
import { useTheme } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import XirrTable from './xirrTable';

export default function Xirr({data,setValue,allTabFilter,setShowXirrVersion,showXirrVersion}) {
  const theme = useTheme();
  // const panelTypes={'overall':'Consolidated Total Portfolio','SP':'Single Premium','RP':'Regular Premium'};
  const panelTypes={'SP':'Single Premium','RP':'Regular Premium'};

  const makeid=()=> {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    
    return text;
    }
  

  return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>

    <div>
      {Object.keys(panelTypes).map((type)=>
      <XirrTable key={makeid()} data={data} type={type} name={panelTypes[type]} setValue={setValue} allTabFilter={allTabFilter} setShowXirrVersion={setShowXirrVersion} showXirrVersion={showXirrVersion}/>
    
      )}
    </div>
    </MuiThemeProvider>
  );
}